<template>
    <div>
        <div class="row justify-content-center">
          <div class="col-md-7" 
           :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <!-- <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjscomment" ></div> -->
            <div style="height:200px;"></div>
            <p class="text-white text-3xl sm:text-5xl  text-center wow"
            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
             style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                Wishes
            </p>
            <p class="text-center text-white font-semibold  text-lg wow"
            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
             style="font-family: 'Urbanist', sans-serif;">
                 Berikan ucapan terbaik untuk <br> kedua mempelai
            </p>
            <div class="p-1 text-xs wow"
            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
            >
                <div class="shadow rounded-lg p-2 bg-white ml-1 sm:ml-0" style="border:2px solid orange;">
                    <div class="text-center">

                    <p class="text-sm">{{td.length}} Ucapan</p>
                    <button type="button" class="text-xs ml-1 rounded-lg shadow p-1 btn btn-sm btn-success  ">{{hadir}} Hadir</button>
                    <button type="button" class="text-xs ml-1 rounded-lg shadow p-1 btn btn-sm btn-danger  ">{{tidakhadir}} Tidak Hadir</button>
                    <button type="button" class="text-xs ml-1 rounded-lg shadow p-1 btn btn-sm bg-gray-500  ">{{ragu}} Ragu</button>
                    <hr>
                    </div>
                    <div id="formcomment" v-if="commented">
                        <form action="" @submit.prevent="submit">
                            <div class="sm-form mt-2">
                                <input required type="text" id="nama" name="nama" class="form-control form-control-sm rounded-lg shadow" placeholder="nama" v-model="vdata.nama" >
                            </div>
                            <div class="sm-form mt-2">
                                <textarea required type="text" id="Pesan" name="Pesan" rows="2" placeholder="Pesan..." class="form-control md-textarea rounded-lg shadow" v-model="vdata.pesan"
                                ></textarea>
                            </div>
                            <div class="sm-form mt-2">
                                <label for="konfirmasi">Konfirmasi Kehadiran</label>
                                <select required class='form-control rounded-lg shadow' v-model="vdata.konfirmasi">
                                <option>Hadir</option>
                                <option>Tidak Hadir</option>
                                <option>Ragu</option>
                                </select>
                            </div>
                       <br>
                       <div class="ml-2 mt-2">
                           <button type="submit" class=" p-1 btn btn-sm btn-style8"><span class="typcn typcn-arrow-right"></span> Kirim</button>
                       </div>
                        </form>
                       <hr>
                       
                    </div>
                    <div v-else>

                    </div>
                    <!-- ============================= -->
                    <div id="commentlist" class="" v-if="td.length>0">
                        <div v-for="(item, index) in td" :key="index+'comment'"> 
                            <div class="d-flex d-flex justify-content-start mt-3" >
                                <div class="align-items-start">
                                    <button type="button"  class="btn btn-sm rounded-circle" :class="`bg-${warna[Math.floor(Math.random()*warna.length)]}-500 text-white font-semibold text-uppercase`" style="height:35px;width:35px;">{{item.nama.charAt(0)}}</button>
                                </div>
                                <div class="align-items-start ml-2">
                                    <p class="font-semibold text-xs pr-3 capitalize">{{item.nama}} <span style="font-size:10px;" :class="`${item.konfirmasi=='Hadir'?'bg-green-500':item.konfirmasi=='Tidak Hadir'?'bg-dark':'bg-gray-500'}`" class="p-1  text-white  rounded-lg shadow ml-2"> <span class="typcn typcn-at"></span> {{item.konfirmasi}}</span></p>
                                    <p class="text-xs text-gray-400 mt-1 mb-2">{{format2(item.tanggal)}}</p>
                                    <p class="text-xs">{{item.pesan}}</p>
                                </div>
                            </div>
                            <hr>
                        </div>
                        <div class="pl-4 pr-4 text-xs">
                            <pagination v-model="page" 
                            :per-page="5"
                            :records="jumlahdata" @paginate="myCallback"/>
                        </div>
                    </div>
                    <br>
                </div>
               
                <div style="height:100px;"></div>
            </div>
            <br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import pagination from 'vue-pagination-2'
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://undangan.officialapp.website";
export default{
  props:['particle'],
    data(){
        return{
            vdata:{},
            ready:false,
            commented:true,
            comments:[],
            hadir:0,
            tidakhadir:0,
            ragu:0,
            jumlahdata:100,
            page:1,
            warna:['gray','red','yellow','green','blue','indigo','purple','pink','red'],
            datanya:[
                {
                    nama:'abc',
                    pesan:'asd',
                    konfirmasi:'Hadir',
                    tanggal:'2021-09-07T23:36',
                    undangan:'1'
                }
            ]
        }
    },
    components:{
        pagination
    },
    computed:{
        td(){
            let that=this;
            let data = this.datanya
            data=data.slice((this.page-1)*5,this.page*5);
            return data
        }
    },
    mounted() {
        // window.particlesJS("particlesjscomment", this.$store.state.particle)
        this.getData();
        if(localStorage.getItem('comment')=='true'){
            this.commented=false;
        }
    },
    methods: {
        async submit(){
            if(confirm('Kirim Pesan ?')){
                this.vdata.tanggal=this.format(new Date())
                this.vdata.undangan=this.$route.query.id
                sdb.collection('app_undangan_comment',false,urlnya).doc().set(this.vdata).then(res=>{
                    this.getData();
                    this.commented=false
                    localStorage.setItem('comment','true');
                    this.$forceUpdate();
                })
            }
        },
        getData(){
            sdb.collection("app_undangan_comment",false,urlnya).doc().select(`select * from app_undangan_comment order by id desc`).then(res => {
                console.log(res);
                this.datanya=res;
                this.jumlahdata=res.length;
                this.hadir=res.filter(e=>e.konfirmasi=='Hadir').length
                this.tidakhadir=res.filter(e=>e.konfirmasi=='Tidak Hadir').length
                this.ragu=res.filter(e=>e.konfirmasi=='Ragu').length
                this.ready=true;
                this.$forceUpdate();
            });
        },
        myCallback(e){
            console.log(e)
        },
         format(tgl) {
              return this.$datefns.format(
                new Date(tgl),
                "YYYY-MM-DDTHH:mm"
              );
        },
        format2(tgl) {
            return this.$datefns.format(
            new Date(tgl),
            "DD MMMM YYYY : HH:ss"
            );
        },
    }
}
</script>